// extracted by mini-css-extract-plugin
export var buttonContainer = "_6e-1";
export var fontSizeSelect = "_6e-3";
export var formatSelect = "_6e-2";
export var formats = "_6e-4";
export var hidden = "_6e-5";
export var icon = "_6e-6";
export var select = "_6e-0";